
export class UserPrivateRealStateModel {
  constructor() {

  }

  async read(_idcod) {
    return await new Promise((resolve, reject) => {
      APICRUD['inmueble'].Read(_idcod || '')
        .then(resolve)
        .catch(error => {
          console.log(error);
          reject({});
        });
    });
  }

  async readHide() {
    return await new Promise((resolve, reject) => {
      APICRUD['inmueble'].ReadHide()
        .then(resolve)
        .catch(error => {
          console.log(error);
          reject({});
        });
    });
  }

  async save(_data, _func) {
    return new Promise((resolve, reject) => {
      APICRUD['inmueble'][_func](_data)
        .then(_result => {
          if (_result.message == 'OK') {
            APICRUD.ClearCache('W3i8cCUg9uNs8Kq3W85Ru9fP1cP16D');
            APICRUD.ClearCache('1QPZ5l1ktk6m8m5L4Xr8n6Fg547Q1e');
            resolve();
          } else {
            reject(_result.message);
          }
        })
        .catch(_error => {
          if (_error && _error != 'KO') {
            reject(_error);
          } else {
            reject('Ocurrió un error al intentar guardar su máquina, por favor revise su información e inténtelo nuevamente.');
          }
        });

    })
  }

  async delete(_idcod) {
    return new Promise((resolve, reject) => {
      APICRUD['inmueble'].Delete(_idcod)
        .then(_result => {
          if (_result.message == 'OK') {
            APICRUD.ClearCache('W3i8cCUg9uNs8Kq3W85Ru9fP1cP16D');
            APICRUD.ClearCache('1QPZ5l1ktk6m8m5L4Xr8n6Fg547Q1e');
            resolve();
          } else {
            reject(_result.message);
          }
        })
        .catch(_error => {
          if (_error && _error != 'KO') {
            reject(_error);
          } else {
            reject('Ocurrió un error al intentar guardar su máquina, por favor revise su información e inténtelo nuevamente.');
          }
        });

    })
  }

}
